<template>
  <section class="adminList">
    <v-container fluid>
      <v-layout>
        <v-flex md12>
          <material-card>
            <v-layout layout row justify-space-between>

              <v-flex
                xs12
                sm3
                md3>
                <v-text-field
                  v-model="search"
                  label="Search SFDC ID"
                  single-line
                  hide-details
                  append-icon="search"
                />
              </v-flex>
              <v-flex
                xs12
                sm3
                md3 offset-md9 align-end>
                <v-checkbox
                  v-model="listArchived"
                  label="Archived"
                  @change="toggleAllArchived($event)"
                />
              </v-flex>
            </v-layout>
            <br>
            <v-data-table
              :search ="search"
              :headers="adminListHeaders"
              :items="filterWorkloads"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              disable-initial-sort
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td>

                  <router-link
                    v-if="$can('manage', 'oppreg')"
                    :to="'/admin/oppreg-administration/admin-content/' + props.item.Project_Id"
                    tag="div"
                    class="view-link"
                    title="View" >
                    <v-icon
                      color="orange"
                      class="mr-2"
                      title="View Workload">
                      visibility
                    </v-icon>
                  </router-link>
                  
                  <span v-else>
                    <v-icon
                      disabled
                      color="orange"
                      class="mr-2"
                      title="View Workload">
                      visibility
                    </v-icon>
                  </span> 

                  <!-- <can
                    i="manage"
                    a="oppreg">
                    <router-link
                      :to="'/admin/oppreg-administration/admin-content/' + props.item.Project_Id"
                      tag="div"
                      class="view-link"
                      title="View" >
                      <v-icon
                        color="orange"
                        class="mr-2"
                        title="View Workload">
                        visibility
                      </v-icon>
                    </router-link>
                  </can> -->
                </td>
                <!-- <td>{{ props.item.Project_Id }}</td> -->
                <td>{{ props.item.SFDC_Id }}</td>
                <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                <td>{{ props.item.Workload_Title }}</td>
                <td>{{ props.item.Customer_Name }}</td>
                <td>{{ props.item.OppReg_Req_Date }}</td>
                <td>{{ props.item.Workload_Status }}</td>
                <td>{{ props.item.Workload_type }}</td>
                <td>{{ props.item.Campaign_Name }}</td>
                <td>{{ props.item.Requestor_Email }}</td>
                <td>{{ props.item.AWS_ACE_ID }}</td>
                <td>{{ props.item.Global_Registered }}</td>
              </template>
            </v-data-table>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      search: '',
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        rowsPerPage: 10,
        sortBy: 'OppReg_Req_Date',
        descending: true
      },
      listArchived: false
    }
  },

  computed: {
    ...mapState('admin/oppregAdmin', ['masterWorkloads', 'adminListHeaders']),
    filterWorkloads () {
      return this.masterWorkloads
    }
  },
  methods: {
    toggleAllArchived () {
      console.log('this',this.listArchived)
      this.$store.dispatch('admin/oppregAdmin/getListArchive', this.listArchived)
    }
  }
}
</script>
<style lang="scss" scoped>
#search-wrapper {
  padding:35px 0  0 0;
  margin:15px 15px;
  background: #2196f3;

  .v-btn {
    margin: 3px 0 !important
 }
//   .search-btn .v-btn__content{
//   // color: #fff !important
// }

.v-btn .v-btn__content {
  color: #fff;
  background-color: none;
  box-shadow: none;
  font-weight: 500;
}
}
.view-link {
    cursor:pointer;
    color: #ff9900 !important
  }

section.adminList{
  table.v-table thead th {
  font-weight: 600
 }

 .v-datatable thead th {
   background-color: #2196f3;
   color: #fff;
   font-weight: 400;

   span{
    //  color: #fff !important;
     font-size:14px !important;
     font-weight:500 !important
   }
 }
}

</style>
